import { render, staticRenderFns } from "./SavedBuildTabs.vue?vue&type=template&id=4d402d12&"
import script from "./SavedBuildTabs.vue?vue&type=script&lang=js&"
export * from "./SavedBuildTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports